import { FC } from "react";
import { Controller, UseControllerProps } from "react-hook-form";
import StyledCheckbox, { ICheckboxProps } from "./index";

const FormCheckbox: FC<UseControllerProps<ICheckboxProps>> = props => {
  const { name, control } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <StyledCheckbox
            error={fieldState.error?.message}
            {...field}
            {...props}
          />
        );
      }}
    />
  );
};
export default FormCheckbox;
